(function () {
  function classifyGender(li) {
    return li.getAttribute('data-gender') || 'other';
  }

  function setupGrouping(grid) {
    var section = grid.closest('.collection');
    if (!section) return;
    var wrapper = section.querySelector('.mobile-gender-groups');
    if (!wrapper) return;

    var groupLists = {
      ladies: wrapper.querySelector('[data-group="ladies"] .mobile-group-grid'),
      gents: wrapper.querySelector('[data-group="gents"] .mobile-group-grid'),
      other: wrapper.querySelector('[data-group="other"] .mobile-group-grid')
    };

    function moveItem(li) {
      var target = groupLists[classifyGender(li)] || groupLists.other;
      if (target) target.appendChild(li);
    }

    function updateVisibility() {
      Object.keys(groupLists).forEach(function (key) {
        var list = groupLists[key];
        if (!list) return;
        var container = list.closest('.mobile-gender-group');
        if (container) container.style.display = list.children.length ? '' : 'none';
      });
    }

    function processExisting() {
      var items = Array.prototype.filter.call(grid.children, function (el) {
        return el.tagName === 'LI';
      });
      items.forEach(moveItem);
      updateVisibility();
    }

    processExisting();

    // Catch products added later by "Load more" / infinite scroll
    var itemObserver = new MutationObserver(function (mutations) {
      var moved = false;
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('grid__item')) {
            moveItem(node);
            moved = true;
          }
        });
      });
      if (moved) updateVisibility();
    });
    itemObserver.observe(grid, { childList: true });
  }

  function init() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('#product-grid.product-grid').forEach(setupGrouping);
  }

  // Re-run whenever facets.js swaps #ProductGridContainer's innerHTML
  // (filter/sort applied). This replaces #product-grid AND
  // .mobile-gender-groups with fresh, empty markup, so grouping must
  // be redone on the new nodes.
  function watchContainerForFilterUpdates() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    var containerObserver = new MutationObserver(function () {
      init();
    });
    // childList only (no subtree) so our own item-moving inside the
    // grouped lists doesn't re-trigger this observer / cause a loop.
    containerObserver.observe(container, { childList: true });
  }

  function start() {
    init();
    watchContainerForFilterUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();